// 3rd party imports
import * as React from 'react';

// bernie
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { Program } from 'models';

export interface CommercialRulesDialogProps {
  dialogId: string;
  l10n?: ILocalization;
  routeStore: RouteStore;
  program: Program;
}

export const CommercialRulesDialog: React.FunctionComponent<CommercialRulesDialogProps> = ({
  dialogId,
  l10n,
  routeStore,
  program,
}) => {
  const onDismiss = () => {
    routeStore.closeDialog();
  };
  const network = program.network.charAt(0) + program.network.slice(1).toLowerCase();

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogCommercialRules" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            <UitkDialogContent>
              <UitkHeading tag="h3" size={5}>
                {l10n.formatText('programs.commercial_rules_dialog.heading.program_commercial_rules', program.title)}
              </UitkHeading>
              <UitkSpacing margin={{ blockstart: 'six' }}>
                <div>
                  <UitkText spacing="three">
                    {l10n.formatText(
                      'programs.commercial_rules_dialog.content.we_will_pay_thru_vendor',
                      network,
                      program.commissionPercentage,
                    )}
                  </UitkText>
                  <UitkText spacing="four">
                    {l10n.formatText(
                      'programs.commercial_rules_dialog.content.guest_must_make_booking_in_x_days',
                      program.title,
                      program.cookieDurationDays,
                    )}
                  </UitkText>
                  <UitkText spacing="four">
                    <LocalizedText message={'programs.commercial_rules_dialog.content.rental_amount_calc'} />
                  </UitkText>
                  <UitkText spacing="four">
                    <LocalizedText message={'programs.commercial_rules_dialog.content.payout_subject_to_t_and_c'} />
                  </UitkText>
                </div>
              </UitkSpacing>
            </UitkDialogContent>
            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={false}
              buttonOne={{
                onClick: onDismiss,
                text: l10n.formatText('common.dialog.close'),
                type: 'primary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
};
